import React from "react";
import "../style/Footer.css";

const Footer = () => {
  return (
    <footer className="footer-wrapper">
      <div className="footer-content">
        <div className="footer-section">
          <h4>About Us</h4>
          <p style={{ fontWeight: 'bold', marginTop: '8px' }}>This project is supported by the National Institute of Standards and Technology (NIST).</p>
        </div>

        <div className="footer-section">
          <h4>Links</h4>
          <ul>
            <li><a href="#events">Events</a></li>
            <li><a href="#partners">Collaborators</a></li>
            <li><a href="mailto:jiangh34@miamioh.edu">Contact</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact</h4>
          <p>PI: Honglu Jiang</p>
          <p>Email: jiangh34@miamioh.edu</p>
          <p>Phone: 513-529-0353</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2026 If we would like to include it. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
